import React from 'react';
import Form from './Form';

const FormContainer = (props: Record<string, any>) => <Form {...props} />;

export default FormContainer;
